import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import {RestService} from './rest.service';
import {News} from '../domain/news';

@Directive()
@Injectable({
    providedIn: 'root'
})
export class NewsService {
    @Output()
    newsLoaded = new EventEmitter<News>();

    constructor(private restService: RestService) {
    }

    loadNews() {
        return this.restService.get<News>('/lookup/news').then(res => {
            this.newsLoaded.emit(res);
        });
    }
}
